import {Component} from '@angular/core';

@Component({
    selector: 'vui-autocomplete-input-dropdown-options',
    templateUrl: './autocomplete-input-dropdown-options.component.html',
    styleUrls: ['./autocomplete-input-dropdown-options.component.scss']
})
export class AutocompleteInputDropdownOptionsComponent {

}
